import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './PollView';
import { voteInPoll } from './redux/actionCreators';
import { canUserVoteInPoll } from './redux/selectors';
import { getIsMobile } from '../publicSession/selectors';

type StateProps = Pick<Props, 'canVote'>;
type DispatchProps = Pick<Props, 'onVote'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (state, { deviation }) => ({
  isMobile: getIsMobile(state),
  canVote: canUserVoteInPoll(state, deviation),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onVote: voteInPoll,
};

export default connect(mapStateToProps, mapDispatchToProps);
